module.exports = __webpack_public_path__ + "img/phone.1a8491c2.png";